import React from "react";

import Header from "Components/Header/Header";
import MobileHeader from "Components/Header/MobileHeader";
import Footer from "Components/Footer/Footer";
import PageHeading from "Components/PageHeading/PageHeading";
import HeadingWithIcon from "Components/landing_page/HeadingWithIcon";
import TestimonialBox from "Components/TestimonialBox/TestimonialBox";

import { TestimonialsPageContainer } from "./Testimonials.style";

export const testimonials = [
    {
        name: "Heather Lehigh",
        role: `EHS - Department Chair Social Sciences`,
        content: "My seniors really love Subjects Masters! Because I can customize the Econ and Government questions, the students share how helpful it is to review before quizzes. The different games create a variety of interaction to keep students stimulated and challenged. It is wonderful to have an application that responds to a teacher's need while motivating students to study! Looking forward to finding new ways to incorporate Subjects Master in my classroom and sharing this website with my fellow teachers. "
    },
    {
        name: "Ryon Everidge",
        role: "After School Tutor",
        content: "I really enjoyed subjects masters. The games provide an amazing learning experience I wish I had when I was in school. Subjects Masters makes me want to learn more. The website has a great mix of games and learning. I believe that if anyone student utilized this website their test scores and grades would increase dramatically. The gaming format providing makes it easy to retain the information."
    },
];

const TestimonialsPage = () => {
    return (
        <TestimonialsPageContainer>
            <Header />
            <MobileHeader />

            <PageHeading
                title={
                    <>
                        Testimonials <span className="redfont"></span>
                    </>
                }
                breadcrumbs={[
                    { label: "Home", path: "/" },
                    { label: "Contact Us" },
                ]}
            />
            <div className="testimonials_content_wrapper">
                <div className="mygrid-container">
                    <div className="testi_heading">
                        <h5 class="subheading">Testimonials</h5>
                        <HeadingWithIcon highlight=" Our Teachers">
                            Hear from
                        </HeadingWithIcon>
                        <p>Our community of educators and families inspires us every day. Hear how Subjects Master is helping students stay motivated, teachers save time, and parents feel confident about their child’s learning journey.</p>
                    </div>
                    <div className="reviews_wrapper">
                        <div className="mygrid-row">
                            {testimonials.map(item => (
                                <div className="mygrid-col-md-4">
                                    <TestimonialBox
                                        text={item.content}
                                        name={item.name}
                                        role={item.role}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </TestimonialsPageContainer>

    );
}

export default TestimonialsPage;
